export const DEG_TO_RAD = (Math.PI / 180)
export const SEPARATION_DISTANCE = 30
export const HALF_SEPARATION_DISTANCE = SEPARATION_DISTANCE * 0.5
export const DRIFT_TARGET = { x: 0, y: 200 }
export const DRIFT_ROTATION_RADIANS = 180 * DEG_TO_RAD
